export const getRandomWords = async (axios, config, params = {}) => {
	return await axios
		.get(`${config.YDR_API_SERVICE}/words/random`, { params })
		.then((response) => {
			return response.status === 200 && response.data.status === "ok"
				? response.data
				: {};
		})
		.catch((err) => {
			if (err.response.status === 404) {
				return {};
			}

			console.error(
				"Could not connect to the random words endpoint. ",
				err
			);

			return {};
		});
};
